import {Box, merge} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import type {PropsWithChildren} from 'react'
import {testIdProps} from '@github-ui/test-id-props'

export const defaultContainerStyles: BetterSystemStyleObject = {
  pr: 1,
  gridArea: 'status',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  gap: 2,
}

export type NestedListItemLeadingContentProps = {
  sx?: BetterSystemStyleObject
}

export function NestedListItemLeadingContent({
  sx: externalSx,
  children,
}: PropsWithChildren<NestedListItemLeadingContentProps>) {
  const containerSx = externalSx
    ? merge<BetterSystemStyleObject>(defaultContainerStyles, externalSx)
    : defaultContainerStyles

  return (
    <Box
      className="nested-listviewitem-leadingcontent"
      {...testIdProps('nested-listview-item-leading-content')}
      sx={containerSx}
    >
      {children}
    </Box>
  )
}

NestedListItemLeadingContent.displayName = 'NestedListItemLeadingContent'
